import { api } from '@/lib/trpc/react';
import { useTeamId, useWorkspaceActions } from './useWorkspace';

export const useMakeFolderTeam = () => {
  const { updateChatbot } = useWorkspaceActions();
  const utils = api.useUtils();
  const teamId = useTeamId();

  return api.sidebar.makeFolderTeam.useMutation({
    // When executed, caller must provide both id and teamId (we fall back to store teamId)
    onMutate: async ({ id, teamId: inputTeamId }) => {
      const prevData = utils.workspace.all.getData();
      const effectiveTeamId = inputTeamId ?? teamId ?? null;

      // Optimistically update workspace cache
      updateChatbot(id, { teamId: effectiveTeamId, groupId: null });

      return { prevData };
    },
    onError: (_err, _vars, context) => {
      if (context?.prevData) {
        utils.workspace.all.setData(undefined, context.prevData);
      }
    },
  });
};
